/*
 * Potzillas — Contact page
 * - Reveal-on-scroll (.pc-reveal -> .is-visible)
 * - FAQ akordeon (single-open: otevreni jedne otazky zavre ostatni ve skupine)
 * Idempotentni: skript se muze nacist z vice sekci, init se da volat opakovane.
 */
(function () {
  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var targets = document.querySelectorAll('.pc-reveal:not(.is-visible)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    targets.forEach(function (t) {
      if (t.dataset.pcObserved === '1') return;
      t.dataset.pcObserved = '1';
      io.observe(t);
    });
  }

  /* ---------- FAQ akordeon (single-open na skupinu) ---------- */
  function initFaq() {
    document.querySelectorAll('[data-pc-faq]').forEach(function (group) {
      if (group.dataset.pcFaqReady === '1') return;
      group.dataset.pcFaqReady = '1';

      var items = Array.prototype.slice.call(group.querySelectorAll('.pc-faq__item'));
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function init() {
    initReveal();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
